
import React, { useState, useContext, useEffect }from 'react';
import { useIonRouter, IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonPage, IonList, IonIcon, IonRefresher, IonRefresherContent } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { searchOutline } from 'ionicons/icons'; // Import the search icon


//import { SelectDateRange } from '../components/SelectDateRange';
//import { Auth_ClientID_context } from '../../../storeState/auth_clientID_context'
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import { App_Header } from '../components/App_Header';
//import { App_Footer } from '../components/App_Footer';

import '../../css/layout.css';
import { RecieptsSlide } from '../components/Tab_Reciepts';
import { OrdersSlide } from '../components/Tab_Orders';
import { ProjectsSlides } from '../components/Tab_Projects';

import { User_Management } from '../components/user_management_services';
import { Helpdesk_Public } from '../../zInternal_Features/merchant/components/Modal_HelpChat_Public';

import { useHistory} from "react-router-dom";


 export function ClientHomePage () {

    let authClient_context = useContext(Auth_MerchantID_context);

    let [acctID, setAccountID ] = useState(authClient_context.acctID);
    let [employeeID, setEmployeeID ] = useState(authClient_context.employeeID);
    let [schema, setSchema ] = useState(authClient_context.schema);
    let [access, setAccessRights ] = useState(authClient_context.accessRights);
    let [sessionID, setSessionID ] = useState(authClient_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authClient_context.baseURL);

    let [receiptsData, setReceiptsData] = useState(false);
    let [ordersData, setOrdersData] = useState(true);
    let [projectsData, setProjectsData] = useState(false);

    let [color_receipts, setColor_receipts] = useState('clear')
    let [color_orders, setColor_orders] = useState('outline')
    let [color_projects, setColor_projects] = useState('clear')

    let [managementService_hotel, setManagementService_hotel] = useState(false);

    let [searchTerm, setSearchTerm] = useState(null);

    let [viewHelpDeskModal, setViewHelpDeskModal] = useState(false);

    let history = useHistory();
    let router = useIonRouter();

    function receiptsHandler()
    {
        setReceiptsData(true);
        setOrdersData(false);
        setProjectsData(false);

        setColor_receipts('outline');
        setColor_orders('clear');
        setColor_projects('clear');


    }
    function ordersHandler()
    {
        setReceiptsData(false);
        setOrdersData(true);
        setProjectsData(false);

        setColor_receipts('clear');
        setColor_orders('outline');
        setColor_projects('clear');

    }
    function projectsHandler()
    {
        setReceiptsData(false);
        setOrdersData(false);
        setProjectsData(true);

        setColor_receipts('clear');
        setColor_orders('clear');
        setColor_projects('outline');

    }

    function handleSearch(e) {

        setSearchTerm(e.target.value);

      };


    const handleHomepage_zasava = () => {

        if (baseURL === "https://ghanaverified.com/") {
            window.location.href = "https://zasava.com";
            //history.push("https://zasava.com");

        } 
        else if (baseURL === "https://ghanaverifiedtest.com/") {
            window.location.href = "https://zasavatest.com";
           // history.push("https://zasavatest.com");
        }
  };

  function handleHomepage(event) {

    // alert(event);
    // alert(window.location.pathname)

        // history.push(event);
        router.push(event, 'forward', 'replace');
        //window.location = event;
    };

    function handleRefresh(event)
    {
        // Optional: Delay to show the spinner briefly
        setTimeout(() => {
            event.detail.complete();   // Stop the spinner
            window.location.reload();  // Reload the entire app
        }, 500);
    }
    //alert("IN MAIN PAGE");
     //alert (authClient_context.authenticated);
     //alert (authClient_context.biometric_fingerprint);
    // alert (authClient_context.device);
    //alert(authClient_context.accessRights);
    //alert(authClient_context.capability);
    //alert(authClient_context.feature);

    return (
            <React.Fragment>
            
            <IonContent fullscreen>

            <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                <IonRefresherContent
                pullingText="Pull to refresh the app"
                refreshingSpinner="circles"
                refreshingText="Refreshing app..."
                />
            </IonRefresher>

                <App_Header></App_Header>

                <IonGrid>
                    <IonRow>
                        {/*<IonCol size = '3'>
                            <IonButton className= 'small-button-tabs' fill={color_receipts} onClick={() => receiptsHandler()}> Receipts </IonButton>
                        </IonCol>*/}
                        <IonCol size = '6'>
                            <IonButton className= 'small-button-tabs' fill={color_orders} onClick={() => ordersHandler()}> Orders </IonButton>
                        </IonCol>
                        <IonCol size = '6'>
                            <IonButton className= 'small-button-tabs' fill={color_projects} onClick={() => projectsHandler()}> Projects </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>


                <IonContent className='appContent'>
                    {/*<BusinessTabs accountID= {acctID} employeeID={ employeeID } schemaName={schema} accessRights={access}/>*/}

                   {/* {receiptsData == true && <RecieptsSlide openModal={ receiptsData } closeModal={() => setReceiptsData(false)}></RecieptsSlide>} */}
                    {ordersData == true && <OrdersSlide openModal={ ordersData } closeModal={() => setOrdersData(false)}></OrdersSlide>}   
                    {projectsData == true && <ProjectsSlides openModal={ projectsData } closeModal={() => setProjectsData(false)}></ProjectsSlides>}

                    {managementService_hotel == true && <User_Management openModal={managementService_hotel} closeModal={() => setManagementService_hotel(false)}></User_Management>}
                    
                    {viewHelpDeskModal == true && <Helpdesk_Public openModal={viewHelpDeskModal} closeModal={() => setViewHelpDeskModal(false)}></Helpdesk_Public>}

                </IonContent>

                <IonFooter className='appFooter'>
                        <IonGrid>
                            <IonRow className='gh_bottom_links_row'>
                                <IonCol size='6'>
                                    <IonButton className="custom-help-button" fill={'clear'} onClick={() => setViewHelpDeskModal(true)}>H</IonButton>
                                </IonCol>
                            {/*{(authClient_context.authenticated != null && (authClient_context.acctID == "U5" || authClient_context.acctID == "U6")) &&
                                    <IonCol className='gh_bottom_links_col_right' size='2'>
                                        <IonButton className='small_button' onClick={() => handleHomepage_zasava()}>Zasava</IonButton>
                                    </IonCol>
                                }*/}
                                <IonCol size='6'>
                                    <IonButton className="custom-public-button" fill={'clear'} onClick={() => handleHomepage('/home')}>P</IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>

                </IonFooter>

                </IonContent>
            </React.Fragment>

    );
};



export default ClientHomePage;

